export enum InfoGeneral {
  telAf = '+33 6 20 70 25 01',
  tel = '+33620702501',
  email = 'contact@kccybersecurity.com',
}
